import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import AuthAxios from "../../config/authAxios"
import apiRoutes from "../apiConfigs"

export const updatePublishUnpublishApi = createAsyncThunk(
    'auth/publish',
    async (data, { rejectWithValue }) => {
        try {
            const response = await AuthAxios.post(apiRoutes.adminAction(`published`, 0), data)
            return response?.data
        } catch (error) {
            return rejectWithValue(error?.response?.data)
        }
    }
)

const updatePublishUnpublishSlice = createSlice({
    name: 'admin publish',
    initialState: { result: [], loading: false, error: null, message: "" },
    extraReducers: (builder) => {
        builder.addCase(updatePublishUnpublishApi.pending, (state, action) => {
            state.loading = true
        })
        builder.addCase(updatePublishUnpublishApi.fulfilled, (state, action) => {
            state.loading = false
            state.result = action?.payload?.result
            state.message = action?.payload?.message
        })
        builder.addCase(updatePublishUnpublishApi.rejected, (state, action) => {
            state.loading = false
            state.error = action?.payload?.error
            state.message = action?.payload?.message
        })
    },
})

export const updatePublishUnpublishReducer = updatePublishUnpublishSlice.reducer